import React from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../helpers/ApiSettings';

const ProductCard = ({ product, viewMode = 'grid' }) => {
    return (
        <div className={`card h-100 shadow-sm hover-shadow transition-all ${viewMode === 'list' ? 'flex-row' : ''}`}>
            <Link 
                to={`/produit/${product.documentId}`} 
                className={viewMode === 'list' ? 'list-image-container' : 'grid-image-container'}
            >
                <img 
                    src={API_BASE_URL + product.images[0].url} 
                    className="card-img-top" 
                    alt={product.titre}
                />
            </Link>
            <div className={`card-body ${viewMode === 'list' ? 'col-8' : ''}`}>
                <h5 className="card-title mb-3">
                    <Link 
                        to={`/produit/${product.documentId}`} 
                    >
                        {product.titre}
                    </Link>
                </h5>
                {viewMode === 'list' && (
                    <p 
                        className="card-text text-muted small mb-3"
                        dangerouslySetInnerHTML={{ __html: product.description?.length > 150 
                            ? product.description.substring(0, 150) + '...' 
                            : product.description 
                        }}
                    />
                )}
                <div className="d-flex justify-content-between align-items-center">
                    <div className="price-tag">
                        <span className="fs-5 fw-bold">{product.daily_price}€</span>
                        <span className="text-muted">/jour</span>
                    </div>
                    <Link 
                        to={`/produit/${product.documentId}`} 
                        className="btn btn-sm btn-primary"
                    >
                        Voir le produit
                    </Link>
                </div>
            </div>

            <style>
                {`
                    .hover-shadow:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
                    }
                    .transition-all {
                        transition: all .2s ease-in-out;
                    }
                    .price-tag {
                        display: flex;
                        align-items: baseline;
                        gap: 4px;
                    }
                    .grid-image-container {
                        height: 200px;
                        overflow: hidden;
                    }
                    .list-image-container {
                        width: 200px;
                        min-width: 200px;
                        height: 200px;
                        overflow: hidden;
                    }
                    .list-image-container img,
                    .grid-image-container img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                    @media (max-width: 768px) {
                        .list-image-container {
                            width: 150px;
                            min-width: 150px;
                            height: 150px;
                        }
                    }
                    @media (max-width: 576px) {
                        .list-image-container {
                            width: 120px;
                            min-width: 120px;
                            height: 120px;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default ProductCard;